import styled from 'styled-components';
import { gray1 } from '@styles/styled/variables';
import BaseChart from '@components/common/Charts/BaseChart';

export const EventContainerEle = styled.div`
  display: flex;
  background-color: #fff;
  border-top: 1px solid ${gray1};
  padding: 8px 0;
`;

export const EventContainerTitle = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 180px;
  align-items: center;
`;

export const EventContainerContent = styled.div`
  flex: 1;
`;

export const StyledBaseChart = styled(BaseChart)`
  width: 100%;
  height: 200px;
`;
